export default "__VITE_ASSET__6e52bd3b__"